import { graphql } from "react-relay";

export const login = graphql`
  mutation LoginMutation($input: LoginInput!) {
    login(input: $input) {
      success
      errors
      token
      tokenExpiresAt
      refreshToken
      refreshTokenExpiresAt
      user {
        id
        profile {
          id
          accountType
        }
      }
    }
  }
`;
